const Languages = () => {
  return (
    <section className="languages">
      <h2 className="title-font  pink-text h2-tag">Languages</h2>
      <section>
        <section>
          <h3>Vietnamese</h3>
          <p>Native language</p>
          <h3>English</h3>
          <p>Advanced working proficiency</p>
        </section>
      </section>
    </section>
  );
};

export default Languages;
